import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { UiSafeStaff } from './commonInterfaces';
import { DataTransform } from './dataTransformFunctions';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';



export interface Attachment {
  id: number,
  workItemId: number,
  mime: string,
  dateAttached: Date,
  staff: UiSafeStaff
  url: string,
  thumbnailUrl: string,
  originalFilename: string
}

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {


  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }


  getAttachmentsForIncident(workItemId: number) {
    return this.http.get<Attachment[]>(this.config.dataApiUrl + '/incidents/' + workItemId + '/attachments').pipe(
      switchMap(DataTransform.replaceAttachmentDatesArray),
     // switchMap(this.addAttachmentPath)
    );
  }

  removeAttachment(workItemId: number, attachmentId: number) {
    return this.http.delete(this.config.dataApiUrl + '/incidents/' + workItemId + '/attachments/' + attachmentId);

  }



  addAttachmentPath = (attachments: Attachment[]) => {
    return of(attachments.map(attachment => {
      attachment.url = this.config.dataApiUrl + '/incidents/' + attachment.workItemId + '/attachments/' + attachment.id;
      attachment.thumbnailUrl = this.config.dataApiUrl + '/incidents/' + attachment.workItemId + '/attachments/' + attachment.id + "/thumbnail";
      return attachment;
    }))

  }
}
